import { NgModule } from '@angular/core';

import { FuseCountdownComponent } from '@fuzz/components/countdown/countdown.component';

@NgModule({
    declarations: [
        FuseCountdownComponent
    ],
    exports: [
        FuseCountdownComponent
    ],
})
export class FuseCountdownModule
{
}
